import React, { useCallback, useEffect, useState } from 'react';
import { TabContext, TabList } from "@mui/lab";
import { Box, Grid, Tab, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import LoadingView from '../../../components/LoadingView/LoadingView';
import restore from "../../../../assets/icons/restore.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { X } from 'lucide-react';
import searchIcon from './../../../../assets/icons/searchIcon 1.png'
const Archive = () => {
    const [value, setValue] = useState("1")
    const [dataRows, setDataRows] = useState([])
    const [foodItemData, setFoodItemData] = useState([]);
    const [menuData, setMenuData] = useState([]);
    const [sectionData, setSectionData] = useState([]);
    const [restaurantId, setRestaurantId] = useState("");
    const [foodItems, setFoodItems] = useState<string[]>([]);
    const [sections, setSections] = useState<string[]>([]);
    const [menus, setMenus] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const FoodItemTable = [
        {
            field: 'name',
            headerName: 'Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'description',
            headerName: 'Description',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'mainsection',
            headerName: 'Main section',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'section',
            headerName: 'Section',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'subsection',
            headerName: 'Sub Section',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'price',
            headerName: 'Price',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
    ];

    const MenuTable = [
        {
            field: 'name',
            headerName: 'Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'menutype',
            headerName: 'Menu Type',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'iconname',
            headerName: 'Icon Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'imgurl',
            headerName: 'Image',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => (
                <img
                    src={params.value}
                    alt='burger'
                    style={{ width: '2rem', height: '2rem' }}
                />
            ),
        },
    ];

    const SectionTable = [
        {
            field: 'name',
            headerName: 'Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'sectionname',
            headerName: 'Section Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'iconname',
            headerName: 'Icon Name',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'imgurl',
            headerName: 'Image',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => (
                <img
                    src={params.value}
                    alt='burger'
                    style={{ width: '2rem', height: '2rem' }}
                />
            ),
        },
    ];

    useEffect(() => {
        let decoded = {};
        const token = localStorage.getItem('restaurant');
        if (token !== null) {
            try {
                decoded = JSON.parse(token);
                setRestaurantId(decoded.id);
            } catch (error) {
                console.log(error)
            }
        }
    }, []);

    const getArchivedFoodItem = useCallback(async () => {
        setLoading(true);
        try {
            const results: any = await axios.get(`${process.env.REACT_APP_SECRET}/api/FoodItems/GetAllArchivedFoodItemByRestaurantId?restaurantId=${restaurantId}`);

            var list = [];

            results.data.forEach((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.itemName,
                    description: dt.description,
                    mainsection: dt.menuName,
                    section: dt.sectionName,
                    subsection: dt.subSection ? dt.subSection : 'N/A',
                    price: dt.itemBasePrice,
                };
                list.push(obj);
            });

            setFoodItemData(list);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [restaurantId])

    const getArchivedMenu = useCallback(async () => {
        try {
            const results: any = await axios.get(`${process.env.REACT_APP_SECRET}/api/Menu/GetAllArchivedMenuByRestaurantId?restaurantId=${restaurantId}`);

            var list = [];

            results.data.forEach((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.menuName,
                    menutype: dt.menuType ? dt.menuType : 'N/A',
                    iconname: dt.iconName,
                    imgurl: dt.url,
                };
                list.push(obj);
            });

            setMenuData(list);
        } catch (error) {
            console.log(error);
        }
    }, [restaurantId]);

    const getArchivedSection = useCallback(async () => {
        try {
            const results: any = await axios.get(`${process.env.REACT_APP_SECRET}/api/Section/GetAllArchivedSectionByRestaurantId?restaurantId=${restaurantId}`)

            var list = [];

            results.data.forEach((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.menuName,
                    sectionname: dt.sectionName,
                    iconname: dt.iconName,
                    imgurl: dt.url,
                };
                list.push(obj);
            });

            setSectionData(list);
        } catch (error) {
            console.log(error);
        }
    }, [restaurantId])

    useEffect(() => {
        getArchivedFoodItem();
        getArchivedMenu();
        getArchivedSection();
    }, [getArchivedFoodItem, getArchivedMenu, getArchivedSection]);

    console.log("restaurant decoded: ", sectionData);
    // useEffect(() => {
    //     const apiAddress = process.env.REACT_APP_SECRET;


    //       let  restaurantIds = [];
    //     restaurantIds.push("329e36b3-b301-45ad-a331-e5a51248b6d9")

    //     //   cancledRes.map((dt, i) => {
    //     //     restaurantId.push(dt.id);
    //     //   });

    //     //   obj=restaurantId;

    //     //   id: ce0a99ad-9c99-417e-87f7-5213d07ff286
    //     //   restaurantsId:  329e36b3-b301-45ad-a331-e5a51248b6d9  
    //     const id = 'ce0a99ad-9c99-417e-87f7-5213d07ff286'

    //       var url = apiAddress + '/api/Menu/allmenuinfo?menuId=' + id;

    //       const Data = restaurantIds;

    //         axios.post(url, Data).then((response) => {
    //           console.log(response.data);

    //           var list = [];
    //           response.data.forEach((dt, i) => {
    //             var obj = {
    //               id: i,
    //               restaurantName: dt.restaurantName,
    //               menuName: dt.menuName,
    //               sectionName: dt.sectionName,
    //               foodName: dt.foodName,
    //             };
    //             list.push(obj);
    //           });
    //           console.log(list);
    //           setDataRows(list);
    //         });

    //   }, []);


    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const getAllSelectedFoodItems = (items: string[]) => {
        setFoodItems(items);
    }

    const getAllSelectedMenus = (items: string[]) => {
        setMenus(items);
    }

    const getAllSelectedSections = (items: string[]) => {
        setSections(items);
    }

    const handleFoodItemRestore = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            // text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        });

        if (confirm.isConfirmed && foodItems.length > 0) {
            try {
                const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/FoodItems/RestoreArchivedFoodItem`, foodItems);
                if (response.status === 200) {
                    toast.success(response.data);
                    getArchivedFoodItem();
                }
            } catch (error) {
                console.log(error);
            }
        }else if(!confirm.isDismissed){
            toast.warn("Select at least one item");
        }
    }

    const handleSectionRestore = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        });

        if (confirm.isConfirmed && sections.length > 0) {
            try {
                const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/Section/RestoreArchivedSection`, sections);
                if (response.status === 200) {
                    toast.success(response.data);
                    getArchivedSection();
                }
            } catch (error) {
                console.log(error);
            }
        }else if(!confirm.isDismissed){
            toast.warn("Select at least one item");
        }
    }

    const handleMenuRestore = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        });

        if (confirm.isConfirmed && menus.length > 0) {
            try {
                const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/Menu/RestoreArchivedMenu`, menus);
                if (response.status === 200) {
                    toast.success(response.data);
                    getArchivedMenu();
                }
            } catch (error) {
                console.log(error);
            }
        }else if(!confirm.isDismissed){
            toast.warn("Select at least one item");
        }
    }

    return (
        <div>
          <LoadingView open={loading} close={() => setLoading(false)} />
            <ToastContainer />
          
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                    >
                        <Tab label="Food Item" value="1" />
                        <Tab label="Menu" value="2" />
                        <Tab label="Section" value="3" />

                    </TabList>
                </Box>
            </TabContext>

            <div className={`${value === '1' ? "d-block " : "d-none"} `}>
                <Grid item className="my-3" title="Restore">
                    <Grid container spacing={2} alignItems='center' justifyContent='space-between'>
                        <Grid item>
                            <div className="roundedCorner" onClick={handleFoodItemRestore}>
                                <img
                                    src={restore}
                                    alt=""
                                    style={{ width: "1rem" }}
                                />
                            </div>
                        </Grid>
                        <Grid item >
                                <Grid item>
                                                              <div
                                                                style={{
                                                                  display: "flex",
                                                                  alignItems: "center",
                                                                  gap: "6px",
                                                                  border: "1px solid #ccc",
                                                                  padding: "6px 10px",
                                                                  borderRadius: "6px",
                                                                  background: "#fff",
                                                                }}
                                                              >
                                                                <img
                                                                  src={searchIcon}
                                                                  alt=""
                                                                  style={{ width: "1rem", opacity: 0.7 }}
                                                                />
                                                          
                                                                      <div
                                  style={{
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="Search..."
                                    style={{
                                      border: "none",
                                      outline: "none",
                                      fontSize: "14px",
                                      paddingRight: "22px", 
                                    }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                  />
                                
                                  {searchQuery && (
                                    <X
                                      size={16}
                                      style={{
                                        position: "absolute",
                                        right: "4px",
                                        cursor: "pointer",
                                        color: "#888",
                                      }}
                                      onClick={() => setSearchQuery("")}
                                    />
                                  )}
                                </div>
                                                              </div>
                                                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Box sx={{ height: 400, width: '100%' }}>
                    <DataGrid
                        rows={
                            searchQuery
                                ? foodItemData.filter((r) => (r.name || "").toString().toLowerCase().includes(searchQuery.toLowerCase()))
                                : foodItemData
                        }
                        columns={FoodItemTable}
                        onRowSelectionModelChange={(item: string[]) => getAllSelectedFoodItems(item)}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                    />
                </Box>
            </div>

            <div className={`${value === '2' ? "d-block " : "d-none"} `}>
                <Box sx={{ height: 400, width: '100%' }}>
                    <Grid item className="my-3" title="Restore">
                        <Grid container spacing={2} alignItems='center' justifyContent='space-between'>
                            <Grid item>
                                <div className="roundedCorner" onClick={handleMenuRestore}>
                                    <img
                                        src={restore}
                                        alt=""
                                        style={{ width: "1rem" }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <TextField
                                    placeholder="Search by name"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <DataGrid
                        rows={
                            searchQuery
                                ? menuData.filter((r) => (r.name || "").toString().toLowerCase().includes(searchQuery.toLowerCase()))
                                : menuData
                        }
                        columns={MenuTable}
                        onRowSelectionModelChange={(item: string[]) => getAllSelectedMenus(item)}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                    />
                </Box>
            </div>

            <div className={`${value === '3' ? "d-block " : "d-none"} `}>
                <Box sx={{ height: 400, width: '100%' }}>
                    <Grid item className="my-3" title="Restore">
                        <Grid container spacing={2} alignItems='center' justifyContent='space-between'>
                            <Grid item>
                                <div className="roundedCorner" onClick={handleSectionRestore}>
                                    <img
                                        src={restore}
                                        alt=""
                                        style={{ width: "1rem" }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <TextField
                                    placeholder="Search by name"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <DataGrid
                        rows={
                            searchQuery
                                ? sectionData.filter((r) => (r.name || "").toString().toLowerCase().includes(searchQuery.toLowerCase()))
                                : sectionData
                        }
                        columns={SectionTable}
                        onRowSelectionModelChange={(item: string[]) => getAllSelectedSections(item)}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                    />
                </Box>
            </div>
        </div>
    );
};

export default Archive;